import Datepicker from 'vue2-datepicker';
const moment = require('moment');

export const typeLanguage = {
  'ptBR': 0,
  'ptPT': 1,
  'es': 2,
  'enUS': 3,
}

const localeMapping = {
  'ptBR': 'pt-br',
  'ptPT': 'pt',
  'es': 'es',
  'en': 'enUS'
}

export const tLang = {
  0: 'ptBR',
  1: 'ptPT',
  2: 'es',
  3: 'enUS',
}


export const initLocale = {
  async init() {
    const locale = localStorage.getItem('companyLocale');
    const browserLocale = navigator.language.replace('-', "");
    
    const datePickerLocale = locale ? localeMapping[tLang[locale]] : localeMapping[browserLocale];
    moment.locale(localeMapping[tLang[locale]] || localeMapping[browserLocale]);
    
    try {
      const localeModule = await require(`vue2-datepicker/locale/${datePickerLocale}`);
      // Datepicker.locale.use(datePickerLocale, localeModule.default);
    } catch (error) {
      console.warn(`Failed to load locale ${datePickerLocale}`, error);
      const ptBRlocale = await require('vue2-datepicker/locale/pt-br');
      // Datepicker.locale.use('pt-br', ptBRlocale.default);
    }

  },
  
  async change(newLocale) {
    const browserLocale = navigator.language.replace('-', "");
    const datePickerLocale = localeMapping[tLang[newLocale]]|| localeMapping[browserLocale];
    console.log('segundo load', localeMapping[tLang[newLocale]], localeMapping[browserLocale])
    moment.locale(localeMapping[tLang[newLocale]] || localeMapping[browserLocale]);
    
    try {

      await require(`vue2-datepicker/locale/${datePickerLocale}`);
      // Datepicker.locale.use(datePickerLocale, localeModule.default);
    } catch (error) {
      console.warn(`Failed to load locale ${datePickerLocale}`, error);
    }
  }
}


// WEBPACK FOOTER //
// ./src/service/setLocaleGlobally/index.js